module.exports = __webpack_public_path__ + "img/Texture_Yellow-Bottom.d152e6f2.svg";